// extracted by mini-css-extract-plugin
export default {"root":"Wishes_root__wLXRR","subtitle":"Wishes_subtitle__-085A","itemWrap":"Wishes_itemWrap__TM-a3","radioGroup":"Wishes_radioGroup__aMqf7"};